export default class Env {
  constructor(data) {
    this.name = data.name;
    this.type = data.type;
    this.path = data.path;

    this._matched = null;
  }

  get matched() {
    if (this._matched !== null) return this._matched;
    const re  = new RegExp(this.path);
    const loc = location.href;
    this._matched = re.test(loc);
    return this._matched;
  }
}



// WEBPACK FOOTER //
// ./src/js/store/modules/config/Env.js